import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @fileoverview MapSheetToggle — chevron button that flips the MapSheet
 * between collapsed (150px) and expanded (420px) snap states on mobile.
 */
import { forwardRef, useCallback } from 'react';
import { useTheme } from '../../../theme';
export const MapSheetToggle = forwardRef(({ isExpanded, onToggle, className, 'data-testid': dataTestId = 'map-sheet-toggle' }, ref) => {
    const theme = useTheme();
    const handleClick = useCallback((e) => {
        e.stopPropagation();
        onToggle();
    }, [onToggle]);
    const prefersReducedMotion = typeof window !== 'undefined' &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const buttonStyle = {
        appearance: 'none',
        background: 'transparent',
        border: 'none',
        // Meets 44px minimum touch target.
        padding: 10,
        minWidth: 44,
        minHeight: 44,
        margin: 0,
        cursor: 'pointer',
        color: theme.colors.textMuted,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.borderRadius.sm,
        transition: prefersReducedMotion ? 'none' : 'transform 200ms ease',
        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
    };
    const label = isExpanded ? 'Collapse event list' : 'Expand event list';
    return (_jsx("button", { ref: ref, type: "button", onClick: handleClick, "aria-label": label, "aria-expanded": isExpanded, "data-testid": dataTestId, className: className, style: buttonStyle, children: _jsx("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: _jsx("polyline", { points: "5 8 10 13 15 8" }) }) }));
});
MapSheetToggle.displayName = 'MapSheetToggle';
